import axios from "axios";
import { API } from "helpers/constants/api";
import * as H from "history";
import moment from "moment-timezone";
import { DATE_TIME_FORMAT, UK_TIMEZONE } from "../constants/common";
import dayjs, { Dayjs } from "dayjs";
import { MessageError } from "types/msg";
import { ISelectListDataViaFragmentItem, ISelectOptionAntd } from "types/data";
import _ from "lodash";
import { message } from "antd";
import { toast } from "react-toastify";
import { MatrixType } from "helpers/types/inputTableMatrix";
import Decimal from "decimal.js";
import { useNavigate } from "react-router-dom";
import { IBasePriceMapItem } from "helpers/types/pricing";

export const downloadFileRest = (response: any, fileName: string) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};

export const bytesToSize = (bytes: number) => {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "n/a";
  const i = Number(Math.floor(Math.log(bytes) / Math.log(1024)));
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
};

export function isEmpty(obj: object) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}

export const renderNoInList = (page: number, index: number, pageSize: number) => {
  const no = (page - 1) * pageSize + index + 1;
  return no < 10 ? "0" + no : no;
};

export const capitalizeFirstLetter = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const convertDateToTimestamp = (dateString: string, isEndDate = false) => {
  const chunks = dateString.split("/");
  const dateObject = moment.tz(`${chunks[2]}-${chunks[1]}-${chunks[0]} 00:00`, UK_TIMEZONE);
  let dateTimestamp = moment(dateObject).format("x");

  if (isEndDate) {
    dateTimestamp = moment(dateObject).add(1, "days").format("x");
    const endDateTimestamp = Number(dateTimestamp) - 1000;
    return endDateTimestamp;
  }

  return Number(dateTimestamp);
};

export const modifyQueryParams = (
  navigate: ReturnType<typeof useNavigate>,
  path: string,
  query: any | URLSearchParams
) => {
  let queryStrings = "";
  if (query instanceof URLSearchParams) {
    queryStrings = query.toString();
  } else {
    queryStrings = new URLSearchParams(query).toString();
  }
  navigate({
    pathname: path,
    search: `?${queryStrings}`,
  });
};

export const convertTimestampToDate = (timestamp: number) => {
  return moment(timestamp).tz(UK_TIMEZONE).format(DATE_TIME_FORMAT);
};

// DD/MM/YYYY -> DDMMYY
export const convertTimeForReportDownload = (date: string) => {
  const divide = date.split("/");
  const year = divide[2].substring(2);
  const newDate = divide[0] + divide[1] + year;
  return newDate;
};

export const transformDropdownListItemResponse = (list: { id: number; name: string }[]) => {
  const newList = list.map((el) => {
    return {
      label: el.name,
      value: el.id,
    };
  });

  return newList;
};

export const titleCase = (str: string) => {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  var splitStr2 = splitStr.join(" ").split("-");
  for (var e = 0; e < splitStr2.length; e++) {
    splitStr2[e] = splitStr2[e].charAt(0).toUpperCase() + splitStr2[e].substring(1);
  }
  return splitStr2.join("-");
};

export const truncateNumberToTwoDecimalWithoutRounding = (original: number | string): number => {
  const with2Decimals = original.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
  return +with2Decimals;
};

export const includeCommasIntoNumber = (number: string) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const roundDecimalNumberForChart = (org: number) => {
  const num = Math.round(org * 10000) / 100;
  if (num === 0) return null;
  return num;
};

export const convertValueToHoldingNumber = (value: string) => {
  let text = value.replace(/\D/g, "");
  if (text.length > 2) {
    text = text.replace(/.{2}/, "$&/");
  }
  if (text.length > 6) {
    text = text.replace(/.{6}/, "$&/");
  }

  return text;
};

export const parseAlternate = (alternateValue: string) => {
  let temps = [];
  try {
    const alternates = JSON.parse(alternateValue);
    temps = alternates.map((el: string) => {
      return {
        name: el,
      };
    });
  } catch {
    temps = [{ name: alternateValue }];
  }
  return temps;
};

export function handleKeyPress(event: React.KeyboardEvent<HTMLInputElement>): void {
  const keyCode: number = event.keyCode || event.which;
  const keyValue: string = String.fromCharCode(keyCode);
  if (!/^\d+$/.test(keyValue)) {
    event.preventDefault();
  }
}

export const convertDataOptions = (arr: Array<any>, nameId: string, nameLabel: string) => {
  return arr && nameId && nameLabel
    ? arr.map((r: any) => {
        return {
          ...r,
          id: r[nameId].toString(),
          label: r[nameLabel],
        };
      })
    : [];
};

export const convertFilter = (arr: Array<any>, arrFilter: string) => {
  return arr && arrFilter
    ? arr.filter((item) => JSON.parse(arrFilter).find((element: string) => element === item.id))
    : [];
};

export const submitLoggers = async (error: any, message: string) => {
  let data = new FormData();
  data.append("body", message + JSON.stringify(error) + " time:" + new Date().toLocaleString());

  await axios.post(API.saveLogWhenUserLoginErrors, data);
};

export const submitClientErrorLog = async (errorMessage: string, stack: string, chunkUrl: string) => {

  const logPayload = {
    errorMessage: errorMessage || "Unknown Frontend Error",
    errorStack: `${stack}\nTime: ${new Date().toLocaleString()}`,
    chunkUrl: chunkUrl,
    currentUrl: window.location.href,
    userAgent: navigator.userAgent
  };

  await axios.post(API.wirteFELog, logPayload);
};

export const isStringEmpty = (str: string): boolean => {
  return !str && str.trim() === '';
}

export const validateNumberOfDigits = (
  event: React.KeyboardEvent<HTMLInputElement>,
  numberInteger: number,
  numberDecimal: number,
  onlyPositiveValue?: boolean | false
) => {
  const char = event.key;
  const input = event.currentTarget;
  const currentValue = input.value;
  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? 0;

  if (!/[\d.-]/.test(char)) {
    event.preventDefault();
    return;
  }

  const proposedValue =
    currentValue.slice(0, selectionStart) + char + currentValue.slice(selectionEnd);

  if (onlyPositiveValue && char === "-") {
    event.preventDefault();
    return;
  }

  if (char === "-" && (selectionStart !== 0 || currentValue.includes("-"))) {
    event.preventDefault();
    return;
  }

  if (char === "." && (currentValue.includes(".") || numberDecimal === 0)) {
    event.preventDefault();
    return;
  }

  const [integerPart = "", decimalPart = ""] = proposedValue.replace("-", "").split(".");

  const integerDigits = integerPart.replace(/\D/g, "").length;
  const decimalDigits = decimalPart.replace(/\D/g, "").length;

  if (
    (!proposedValue.includes(".") || selectionStart <= proposedValue.indexOf(".")) &&
    integerDigits > numberInteger &&
    /\d/.test(char)
  ) {
    event.preventDefault();
    return;
  }

  if (
    proposedValue.includes(".") &&
    selectionStart > proposedValue.indexOf(".") &&
    decimalDigits > numberDecimal &&
    /\d/.test(char)
  ) {
    event.preventDefault();
    return;
  }
};

export const handleTrimInput = (e: React.ChangeEvent<HTMLInputElement>) => {
  e.target.value = e.target.value.trim();
};

export const handleKeyDownOnlyNumbersAndSpace = (event: React.KeyboardEvent<HTMLInputElement>) => {
  const key = event.key;
  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter"];

  const isNumber = /^[0-9]$/.test(key);
  const isSpace = key === " ";
  const isAllowed = allowedKeys.includes(key);
  if (event.ctrlKey || event.metaKey) {
    return;
  }
  if (!isNumber && !isSpace && !isAllowed) {
    event.preventDefault();
  }
};

export const getNextAvailableTime = (disabledTimes: string[], currentTime: Dayjs) => {
  const generateTimes = () => {
    const times: string[] = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 10) {
        const timeStr = dayjs().hour(hour).minute(minute).second(0).format("HH:mm");
        times.push(timeStr);
      }
    }
    return times;
  };
  const isToday = currentTime.isSame(dayjs(), "day");
  const dayCompare = isToday
    ? dayjs()
    : currentTime.subtract(1, "day").hour(23).minute(59).second(59);
  const dayString = currentTime.format("DD/MM/YYYY");

  const allTimes = generateTimes();
  for (const timeStr of allTimes) {
    const time = dayjs(dayString + " " + timeStr, "DD/MM/YYYY HH:mm");
    if (time.isAfter(dayCompare) && !disabledTimes.includes(timeStr)) {
      return timeStr;
    }
  }
  return "00:00";
};

export const blockEnterCharacter = (event: any) => {
  const charCode = event.charCode;
  if (!((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 45)) {
    event.preventDefault();
    return;
  }
};

export const handleErrorMess = (errorCode: string, objErr: any, errorMessage?: string) => {
  return (
    (errorCode && MessageError?.[objErr]?.[errorCode]) || errorMessage || MessageError?.default
  );
};

export const handleToastErrorMsg = (errorMessage?: string) => {
  toast.error(errorMessage || MessageError?.default);
};

export const includesChar = (text: string, char: string): boolean => {
  return text.toLowerCase().includes(char.toLowerCase());
};

export const handleAddOrRemoveItemInStringArray = (array: string[], item: string) => {
  const index = array.indexOf(item);
  if (index > -1) {
    return array.filter((i) => i !== item);
  } else {
    return [...array, item];
  }
};

export const filterOptionSelectAntd = (input: string, option: any) => {
  return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
};

export const onKeyDownInputNumberValidate = (
  e: React.KeyboardEvent<HTMLInputElement>,
  { min, max, decimal = 0 }: { min?: number; max?: number; decimal?: number }
) => {
  if (e.ctrlKey || e.metaKey) return;

  const char = e.key;
  const input = e.currentTarget;
  const { value, selectionStart = 0, selectionEnd = 0 } = input;

  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Home",
    "End",
    "Enter",
  ];
  if (allowedKeys.includes(char)) return;
  const isDigit = /^\d$/.test(char);
  const isDot = char === ".";
  const isMinus = char === "-";

  if (isMinus) {
    const hasMinus = value.includes("-");
    const isAtStart = selectionStart === 0;
    if ((typeof min === "number" && min >= 0) || hasMinus || !isAtStart) {
      e.preventDefault();
    }
    return;
  }

  if (!isDigit && (!decimal || !isDot)) {
    e.preventDefault();
    return;
  }
  if (!/^[\d.]$/.test(char)) {
    e.preventDefault();
    return;
  }
  const nextValue = value.slice(0, selectionStart) + char + value.slice(selectionEnd);
  const dotCount = (nextValue.match(/\./g) || []).length;
  if (dotCount > 1) {
    e.preventDefault();
    return;
  }
  const [, decimals = ""] = nextValue.split(".");
  if (dotCount === 1 && decimals.length > decimal) {
    e.preventDefault();
    return;
  }

  const numericValue = parseFloat(nextValue);

  if (!isNaN(numericValue)) {
    if (typeof min === "number" && numericValue < min) {
      e.preventDefault();
      return;
    }
    if (typeof max === "number" && numericValue > max) {
      e.preventDefault();
    }
  }
};

export const handleKeyPressDecimalNumber = (
  event: any,
  numberInteger: number,
  numberDecimal: number,
  onlyPositiveValue?: boolean | false
) => {
  blockEnterCharacter(event);
  validateNumberOfDigits(event, numberInteger, numberDecimal, onlyPositiveValue);
};

// Pricing Management -----------------------------------------------------------------------------
export const convertDataToAntdType = (
  list: ISelectListDataViaFragmentItem[],
  isKeepOriginal?: boolean
): ISelectOptionAntd[] => {
  const newList = list.map((el) => {
    const base = { value: el.code, label: el.descr };
    return isKeepOriginal ? { ...base, optional: el } : base;
  });
  return newList.sort((a, b) => a.label.localeCompare(b.label));
};

export const toggleValue = (list: string[], value: string) =>
  list.includes(value) ? list.filter((v) => v !== value) : [...list, value];

export const filterValuesByTypes = (
  values: ISelectOptionAntd[],
  selectedTypes: string[]
): ISelectOptionAntd[] => {
  if (selectedTypes.length === 0) return values;
  return values.filter(
    (item) => item.optional?.type !== undefined && selectedTypes.includes(item.optional.type)
  );
};
export const generateRangeText = (from: number | undefined, to: number | undefined) => {
  return from && to
    ? from + " - " + to
    : !from && to
    ? "Under " + to
    : from && !to
    ? "Over " + from
    : "";
};

export const filterBreedsByBreedTypes = (
  breeds: ISelectOptionAntd[],
  selectedBreedTypes: string[]
): ISelectOptionAntd[] => {
  if (selectedBreedTypes.length === 0) return breeds;
  return breeds.filter(
    (item) => item.optional?.type !== undefined && selectedBreedTypes.includes(item.optional.type)
  );
};
// End Pricing Management -----------------------------------------------------------------------------

export const generateTempId = () => `${Date.now()}-${Math.random()}`;

export const formatDisplayIdAndName = (id?: string | number, name?: string | number): string => {
  return id != null && name != null
    ? `${id} - ${name}`
    : id != null
    ? `${id}`
    : name != null
    ? `${name}`
    : "";
};

export const convertDataToSelect = (
  list: any[],
  valueField: string,
  labelField: string,
  isShowAllIdAndName?: boolean,
  isKeepOriginal?: boolean
): ISelectOptionAntd[] => {
  const newList = list.map((el) => {
    const base = {
      value: el[valueField],
      label: isShowAllIdAndName
        ? formatDisplayIdAndName(el[valueField], el[labelField])
        : el[labelField],
    };
    return isKeepOriginal ? { ...base, optional: el } : base;
  });
  return newList.sort((a, b) => a.label.localeCompare(b.label));
};

export const convertToLabelValue = (
  arr: string[],
  map: Record<string, string>,
  isShowIdAndName?: boolean
): { value: string; label: string }[] => {
  return arr.map((id) => ({
    value: id,
    label: isShowIdAndName ? formatDisplayIdAndName(id, map[id]) : map[id],
    optional: { id: id, name: map[id] },
  }));
};

export const parseArrayString = (str: string): (string | number)[] => {
  try {
    const parsed = JSON.parse(str);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const safeMinus = (a: any, b: any, decimal: number = 0): number | null => {
  if (_.isFinite(a) && _.isFinite(b)) {
    return _.round((a as number) - (b as number), decimal);
  }
  return 0;
};

export const safeAdd = (a: any, b: any, decimals: number = 2): number => {
  const toNumber = (val: any): number => {
    const n = Number(val);
    return isNaN(n) ? 0 : n;
  };

  const sum = toNumber(a) + toNumber(b);
  const factor = 10 ** decimals;
  return Math.round(sum * factor) / factor;
};

export const safeMin = (numbers: (number | null | undefined)[]): number | undefined => {
  const filtered = numbers.filter((n): n is number => typeof n === "number");
  return _.min(filtered);
};

export function safeMultiply(a: number | string, b: number | string) {
  const valA = (a === null || a === undefined) ? 0 : a;
  const valB = (b === null || b === undefined) ? 0 : b;
  return new Decimal(valA).mul(new Decimal(valB)).toNumber();
}

export const formatNumberLabel = (
  value: number | string | null | undefined,
  decimal: number = 2
): string => {
  const num = Number(value);
  if (!isNaN(num)) {
    return num.toLocaleString(undefined, {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    });
  }
  return "";
};
export const formatGBP = (amount: number) => {
  const num = Number(amount);
  if (!isNaN(num)) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }
  return "";
};
export const sumFieldDecimal = <T extends Record<string, any>>(
  data: readonly T[],
  field: keyof T,
  decimalPlaces: number = 2
): number => {
  return data
    .reduce((sum, item) => {
      const value = item[field] ?? 0;
      const roundedValue = new Decimal(value).toDecimalPlaces(
        decimalPlaces,
        Decimal.ROUND_HALF_UP
      );
      return sum.add(roundedValue);
    }, new Decimal(0))
    .toNumber();
};
export const formatDateString = (input: string | number): string => {
  const str = input.toString().padStart(8, "0");
  const day = str.slice(0, 2);
  const month = str.slice(2, 4);
  const year = str.slice(4, 8);
  return `${day}/${month}/${year}`;
};

export const handleCopy = (value: string) => {
  navigator.clipboard
    .writeText(value)
    .then(() => message.success("Copied"))
    .catch(() => message.error("Have something wrong:"));
};

export const findPureLabelInCombineValueLabel = (label: string): string => {
  return label.split(" - ")[1]?.trim() ?? "";
};

export const reserseYLabel = (gridType: MatrixType) => {
  let yLabel: string[] = gridType?.yLabels;
  let reserseYlabel = [...yLabel].reverse();
  const reverseVal = {
    ...gridType,
    yLabels: reserseYlabel,
  };
  return reverseVal;
};

export const nextState = (current: boolean | null): boolean | null => {
    if (current === null) return true;
    if (current === true) return false;
    return null;
};

export const getFilterSingleValue = (filterVal: any) => {
  if (!filterVal || filterVal.length === 0) return null;
  if (Array.isArray(filterVal)) return filterVal.length === 1 ? filterVal[0] : null;
  return filterVal;
};

export const formatNumber = (value?: number) => {
  if (value === undefined || value === null) {
    return "";
  }

  return new Intl.NumberFormat("en-GB").format(value);
};

export const formatDecimal = (value?: number) => {
  if (value === undefined || value === null) {
    return "";
  }

  return new Intl.NumberFormat("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const isStringEqual = (str1: string, str2: string, isIgnoreCase?: boolean) => {
  if(!str1 || !str2) return false;
  str1 = str1.trim();
  str2 = str2.trim();
  if(isIgnoreCase === true)
    return str1.toLocaleLowerCase() === str2.toLocaleLowerCase();
  return str1 === str2;
}

export const getEffectiveNewBp = (
    self: string,
    mapItem?: Pick<IBasePriceMapItem, "presetBp" | "newBp">
) => {
    if (!mapItem) return 0;
    return self === "Y" ? mapItem.presetBp : mapItem.newBp;
};

export const getEffectiveBonusValue = (
  self: string,
  bonusValue: { bonusImm: number; bonusDef: number; bonusPaymentPpkImmediate: number }
) => {
  if (self === "Y") {
    return { bonusImm: 0, bonusDef: 0, bonusPaymentPpkImmediate: 0 };
  }
  return bonusValue;
};
